var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconReportMileage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,0)",
    d: "M25.005 21 31 27l-4 4-6-6v-4h4.005zM24 10a2 2 0 0 1 2 2v8h-2v-8H12v16h11v2H12a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2h12zm.177 13h-1.178v1.17L27 28.171l1.172-1.173L24.177 23zM19 22a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2h4zm2-4a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2h6zm0-4a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2h6z",
    fill: "#FFF",
    fillRule: "evenodd",
    className: "invert-light"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconReportMileage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-report-mileage.dabe289564afd69bcd86852d8a94107a.svg";